import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

import { ActivateLineMessageQuotaDocument } from '~/graphql/generated/graphql';

export const useActivateLineMessageQuota = () => {
  const [activateMutation, activateResult] = useMutation(ActivateLineMessageQuotaDocument);

  const activateLineMessageQuota = useCallback(
    async (lineVisitorId: string) => {
      await activateMutation({
        variables: { lineVisitorId },
      });
    },
    [activateMutation],
  );

  return {
    activateLineMessageQuota,
    activateLoading: activateResult.loading,
    called: activateResult.called,
  };
};
